<template>
  <div class="inline-flex ml-1.5 text-xl gap-0.5">
    <span v-for="i in 3" :class="[`dot${i}`]">.</span>
  </div>
</template>

<script>
export default {
  name: 'WaitingDots'
}
</script>
<style scoped>
.dot1 {
  animation: dot1-animation 2s linear infinite;
}

.dot2 {
  animation: dot2-animation 2s linear infinite;
}

.dot3 {
  animation: dot3-animation 2s linear infinite;
}


@keyframes dot1-animation {
  from {
    @apply opacity-0;
  }
  20% {
    @apply opacity-0;
  }
  21% {
    @apply opacity-100;
  }
  to {
    @apply opacity-100;
  }
}

@keyframes dot2-animation {
  from {
    @apply opacity-0;
  }
  35% {
    @apply opacity-0;
  }
  36% {
    @apply opacity-100;
  }
  to {
    @apply opacity-100;
  }
}

@keyframes dot3-animation {
  from {
    @apply opacity-0;
  }
  50% {
    @apply opacity-0;
  }
  51% {
    @apply opacity-100;
  }
  to {
    @apply opacity-100;
  }
}
</style>